import Vue from 'vue'
import { SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from "constants"

/**
 * Provide a formatted name from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_name(item) {
    if(item !== null) {
        if (item.NamFirst && item.NamMiddle && item.NamLast) {
            return `${item.NamLast}, ${item.NamFirst} ${item.NamMiddle} `
        }
        else if(item.NamFirst && item.NamLast) {
            return `${item.NamLast}, ${item.NamFirst} `
        }
        else if(item.NamLast) {
            return `${item.NamLast} `
        }
    }
    return 'Error formatting name!'
}

/**
 * Provide a thumbnail image from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_thumbnail_image(item) {
    if (item !== null) {
        if(item.media && item.media.url) {
            return `url('${item.media.url}')`
        }
    }
    return `url('${process.env.VUE_APP_PUBLIC_PATH || '/'}/images/baseline-person-24px.svg')`;
}

/**
 * Provide a thumbnail image url from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_thumbnail_url(item) {
    if (item !== null) {
        if (item.media && item.media[0] && item.media[0].sizes && item.media[0].sizes.small && item.media[0].sizes.small.url) {
            return item.media[0].sizes.small.url;
        }
    }
    return `${process.env.VUE_APP_PUBLIC_PATH || '/'}/images/baseline-person-24px.svg`
}

/**
 * Provide a large image from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_large_image(item) {
    if(item !== null) {
        if (item.media && item.media[0] && item.media[0].sizes && item.media[0].sizes.medium && item.media[0].sizes.medium.url) {
            let caption = item.media[0].DetCoverage ? item.media[0].DetCoverage : '';
            return {
                url: item.media[0].sizes.medium.url,
                caption: caption
            }
        }
    }

    return "";
}

/**
 * Provide a list of images from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_images(item) {
    if(item !== null) {
        if (item.related && item.related.length > 0) {
            let images = item.related.map(function (item) {
                let url = '';
                if (item.sizes && item.sizes.large && item.sizes.large.url) url = item.sizes.large.url;

                let caption = '';
                if (item.DetCoverage) caption = item.DetCoverage;

                return {
                    url: url,
                    caption: caption
                };
            });

            return images;
        }
    }

    return [];
}

/**
 * Provide a list of thumbnails from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_image_thumbnails(item) {
    if (item.related && item.related.length > 0) {
        let images = item.related.map(function (item) {
            let url = '';
            if (item.sizes && item.sizes.small && item.sizes.small.url) url = item.sizes.small.url;
            let caption = '';
            if (item.DetCoverage) caption = item.DetCoverage;

            return {
                url: url,
                caption: caption
            };
        });

        return images;
    }

    return [];
}

/**
 * Provide a formatted list of units from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_units(item) {
    if(item !== null) {
        if (item.MilUnit_tab && item.MilUnit_tab.length) {
            return formattedList(item.MilUnit_tab);
        }
    }
    return "";
}

/**
 * Provide a formatted list of branches from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_branch(item) {
    if(item !== null) {
        if (item.MilBranch_tab && item.MilBranch_tab.length) {
            return formattedList(item.MilBranch_tab);
        }
    }
    return "";
}

/**
 * Provide a formatted list of service components from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_services(item) {
    if(item !== null) {
        if (item.MilServiceComponent_tab && item.MilServiceComponent_tab.length) {
            return formattedList(item.MilServiceComponent_tab);
        }
    }
    return "";
}

function formattedList(array){
    var list = "";
    for (var i = 0; i < array.length; i++){
        if (i > 0){
            list += ", ";
        }
        list += array[i];
    }
    return list;
}

/**
 * Provide a formatted service number from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_service_numbers(item) {
    if(item !== null) {
        if (item.BioServiceNumber_tab) {
            return `${item.BioServiceNumber_tab}`
        }
    }
    return "";
}

/**
 * Provide a biography from the provided `item`
 * @param {*} item Dictionary based on `RecipientModel` object
 */
export function recipient_biography(item) {
    if(item !== null) {
        if (item.narratives && item.narratives[0] && item.narratives[0].NarNarrative) {
            return `${item.narratives[0].NarNarrative}`;
        }
    }
    return '';
}



